import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createWallet as universalCreateWallet, getOrCreateWallet as universalGetOrCreateWallet, createCustomerReference as universalCreateCustomerReference, getCustomerReference as universalGetCustomerReference, updateCustomerReference as universalUpdateCustomerReference, deleteCustomerReference as universalDeleteCustomerReference, getWallet as universalGetWallet, getWalletGiftCard as universalGetWalletGiftCard, queryWallets as universalQueryWallets, countWallets as universalCountWallets, queryWalletsByContact as universalQueryWalletsByContact, } from './rise-v1-wallet.universal';
import { GiftCardType, InitiatorType, SortOrder, WebhookIdentityType, } from './rise-v1-wallet.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.rise.v1.wallet', module_name: 'wix-rise.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createWallet: (customerReference, options) => {
            const methodLogData = {
                method_name: 'createWallet',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.createWallet',
            };
            return universalCreateWallet(customerReference, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getOrCreateWallet: (customerReference, options) => {
            const methodLogData = {
                method_name: 'getOrCreateWallet',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.getOrCreateWallet',
            };
            return universalGetOrCreateWallet(customerReference, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createCustomerReference: (customerReference) => {
            const methodLogData = {
                method_name: 'createCustomerReference',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.createCustomerReference',
            };
            return universalCreateCustomerReference(customerReference, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getCustomerReference: (query) => {
            const methodLogData = {
                method_name: 'getCustomerReference',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.getCustomerReference',
            };
            return universalGetCustomerReference(query, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateCustomerReference: (customerReference) => {
            const methodLogData = {
                method_name: 'updateCustomerReference',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.updateCustomerReference',
            };
            return universalUpdateCustomerReference(customerReference, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteCustomerReference: (query) => {
            const methodLogData = {
                method_name: 'deleteCustomerReference',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.deleteCustomerReference',
            };
            return universalDeleteCustomerReference(query, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getWallet: (query) => {
            const methodLogData = {
                method_name: 'getWallet',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.getWallet',
            };
            return universalGetWallet(query, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getWalletGiftCard: (query) => {
            const methodLogData = {
                method_name: 'getWalletGiftCard',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.getWalletGiftCard',
            };
            return universalGetWalletGiftCard(query, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryWallets: () => {
            const methodLogData = {
                method_name: 'queryWallets',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.queryWallets',
            };
            return universalQueryWallets(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countWallets: (options) => {
            const methodLogData = {
                method_name: 'countWallets',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.countWallets',
            };
            return universalCountWallets(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryWalletsByContact: (query) => {
            const methodLogData = {
                method_name: 'queryWalletsByContact',
                service_name: 'wix.rise.v1.WalletService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-rise.v2,entity=wix.rise.v1.wallet,environment=velo-frontend,method-fqn=wix.rise.v1.WalletService.queryWalletsByContact',
            };
            return universalQueryWalletsByContact(query, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        GiftCardType,
        InitiatorType,
        SortOrder,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=rise-v1-wallet.frontend.js.map